import { EmailAuthProvider, reauthenticateWithCredential, signOut } from 'firebase/auth';
import { httpsCallable } from 'firebase/functions';
import { auth, functions } from './firebase';

export const deleteTapTapAccount = async (password) => {
  const current = auth.currentUser;
  if (!current) throw new Error('Please sign in before deleting your account.');
  await reauthenticateWithCredential(current, EmailAuthProvider.credential(current.email, password));
  await current.getIdToken(true);
  await httpsCallable(functions, 'deleteAccount')();
  await signOut(auth);
};
